"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _categories = require("@insided/shared/utils/categories");

var _contentType = require("@insided/shared/utils/contentType");

var _common = require("@insided/shared/utils/common");

var _CategoryDropdown = _interopRequireDefault(require("@insided/shared/uikit/CategoryDropdown"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _ArrowDropdown = _interopRequireDefault(require("@insided/destination/icons/ArrowDropdown"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var filterCategoriesForContentType = function filterCategoriesForContentType(categories, contentType) {
  var isCategoriesV2Enabled = _common.common.isModuleActive('categoriesV2IdeasAndPU');

  if (!isCategoriesV2Enabled && (0, _contentType.isIdea)(contentType)) {
    return {};
  }

  var filtered = (0, _categories.filterCategoriesBySupportedContentType)(categories, contentType);

  if ((0, _contentType.isIdea)(contentType)) {
    var withoutGroups = {};
    Object.entries(filtered).forEach(function (_ref) {
      var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
          type = _ref2[0],
          categoryList = _ref2[1];

      if (!_categories.groupModuleTypes.includes(Number(type))) {
        withoutGroups[type] = categoryList;
      }
    });
    filtered = withoutGroups;
  }

  return filtered;
};

var CategorySelect = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CategorySelect, _Component);

  var _super = _createSuper(CategorySelect);

  function CategorySelect() {
    var _this;

    (0, _classCallCheck2.default)(this, CategorySelect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "eventListener", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      selectedCategoryId: _this.props.selectedCategoryId,
      currentContentType: (0, _contentType.getConsistentContentType)(_this.props.contentType),
      filteredCategories: filterCategoriesForContentType(_this.props.categories, (0, _contentType.getConsistentContentType)(_this.props.contentType))
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dispatchCategorySelectedEvent", function (selectedCategoryId) {
      var categorySelectedEventForGroupJoin = _this.props.categorySelectedEventForGroupJoin;
      var filteredCategories = _this.state.filteredCategories;

      if (selectedCategoryId && categorySelectedEventForGroupJoin) {
        var selectedCategory = (0, _categories.findCategoryById)((0, _categories.getMergedCategoryList)(filteredCategories), Number(selectedCategoryId));
        document.dispatchEvent(new window.CustomEvent('topic:category_selected', {
          detail: {
            id: selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.id,
            label: selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.title,
            types: [selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.type]
          }
        }));
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", function () {
      var selectedCategoryId = _this.props.selectedCategoryId; // Delay dispatching the event by 500 milliseconds to give enough time for the event listener to be added

      setTimeout(function () {
        _this.dispatchCategorySelectedEvent(selectedCategoryId);
      }, 500);

      _this.eventListener = function (event) {
        var newContentType = event.detail.contentType;

        if (newContentType !== _this.state.currentContentType) {
          var filteredCategories = filterCategoriesForContentType(_this.props.categories, newContentType);
          var currentSelectedCategoryId = _this.state.selectedCategoryId;
          var newSelectedCategoryId = currentSelectedCategoryId;

          if (currentSelectedCategoryId) {
            var categoryStillValid = (0, _categories.findCategoryById)((0, _categories.getMergedCategoryList)(filteredCategories), Number(currentSelectedCategoryId));

            if (!categoryStillValid) {
              newSelectedCategoryId = null;
            }
          }

          _this.setState({
            currentContentType: newContentType,
            selectedCategoryId: newSelectedCategoryId,
            filteredCategories: filteredCategories
          });
        }
      };

      document.addEventListener('topic:content_type_changed', _this.eventListener);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentWillUnmount", function () {
      if (_this.eventListener) {
        document.removeEventListener('topic:content_type_changed', _this.eventListener);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSelectCategory", function (category) {
      var _category$id, _category$id2;

      if (category !== null && category !== void 0 && category.isContainer) {
        return;
      }

      _this.dispatchCategorySelectedEvent((_category$id = category === null || category === void 0 ? void 0 : category.id) !== null && _category$id !== void 0 ? _category$id : null);

      _this.setState({
        selectedCategoryId: (_category$id2 = category === null || category === void 0 ? void 0 : category.id) !== null && _category$id2 !== void 0 ? _category$id2 : null
      });
    });
    return _this;
  }

  (0, _createClass2.default)(CategorySelect, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          selectedCategoryId = _this$state.selectedCategoryId,
          filteredCategories = _this$state.filteredCategories;
      var selectedCategory = null;

      if (selectedCategoryId) {
        selectedCategory = (0, _categories.findCategoryById)((0, _categories.getMergedCategoryList)(filteredCategories), Number(selectedCategoryId));
      }

      var dropdownTitle = selectedCategory ? (0, _preact.h)("span", null, selectedCategory.title) : (0, _preact.h)(_phrase.default, {
        p: "Choose your subject"
      });
      return (0, _preact.h)("div", null, filteredCategories && selectedCategory && (0, _preact.h)("input", {
        type: "hidden",
        name: "topic[forum]",
        id: "topic_category",
        value: selectedCategory.id
      }), (0, _preact.h)(_CategoryDropdown.default, {
        categories: filteredCategories,
        trigger: (0, _preact.h)("div", null, dropdownTitle, (0, _preact.h)(_ArrowDropdown.default, null)),
        triggerClass: "dropdown-selector-wrapper--destination",
        onSelectCategory: this.onSelectCategory
      }));
    }
  }]);
  return CategorySelect;
}(_preact.Component);

var _default = CategorySelect;
exports.default = _default;